// src/services/session.js
import api from "api/axios";

/** Renvoie l'utilisateur courant (ou null) — accepte un axios config (ex: headers). */
export const whoAmI = async (config = {}) => {
  try {
    const { data } = await api.get("/users/me/", config);
    return data;
  } catch (err) {
    const s = err?.response?.status;
    if (s === 401 || s === 403) return null;
    throw err;
  }
};

export const logout = async () => {
  try {
    await api.post("/users/logout/");
  } catch {
    try {
      await api.post("/quickbooks/logout/");
    } catch {}
  } finally {
    try {
      localStorage.removeItem("user");
      localStorage.removeItem("company");
      localStorage.removeItem("user_id");
      localStorage.removeItem("expires_at");
    } catch {}
  }
};
